/** Higher urgency first. Difficulty is not a sort key. Date and fit stay as tie-breakers. */
export const CALL_CENTER_TASK_PRIORITY_ORDER = {
  callCenterUrgency: "desc",
} as const;

export function compareCallCenterTaskPriority(
  a: { callCenterUrgency?: number | null },
  b: { callCenterUrgency?: number | null },
) {
  return (b.callCenterUrgency ?? 0) - (a.callCenterUrgency ?? 0);
}
